import {
  put, takeLatest, takeEvery, all, select,
} from 'redux-saga/effects';
import { notification } from 'antd';
import ActivityLogActions, { activityLogActionTypes } from '@Actions/activityLogActions';
import TrackerActions from '@Actions/trackerActions';
import ActivityLogServices from '@Services/activityLogServices';

/**
 * @param action
 */
function* _getActivityLog(action) {
  const {
    entityId, entityName, page, limit,subEntityId
  } = action;
  try {
    yield put(ActivityLogActions.getActivityLogLoading(true, entityName));
    const state = yield select();
    const orgId = state.UserReducers?.user?.tenant_info?.org_id;
    const activityLog = yield ActivityLogServices.getActivityLog(entityId, entityName, page, limit, orgId,subEntityId);
    yield put(ActivityLogActions.getActivityLogSuccess(activityLog, entityName));
    if (action?.callback) action.callback();
    yield put(ActivityLogActions.getActivityLogLoading(false, entityName));
  } catch (error) {
    yield put(ActivityLogActions.getActivityLogLoading(false, entityName));
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(activityLogActionTypes.GET_ACTIVITY_LOG.ERROR, error));
  }
}

/**
 *
 */
function* getActivityLog() {
  yield takeEvery(activityLogActionTypes.GET_ACTIVITY_LOG.REQUEST, _getActivityLog);
}

function* _addActivityLog(action) {
  try {
    yield put(ActivityLogActions.addActivityLogLoading(true));
    const { payload } = action;
    const activityLog = yield ActivityLogServices.addActivityLog(payload);
    if (activityLog.success) {
      notification.open({
        type: 'success',
        message: 'Comment added successfully',
        duration: 4,
        placement: 'top',
      });
    }
    if (action?.callback) action.callback();
    yield put(ActivityLogActions.addActivityLogLoading(false));
  } catch (error) {
    yield put(ActivityLogActions.addActivityLogLoading(false));
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(activityLogActionTypes.ADD_ACTIVITY_LOG.ERROR, error));
  }
}

/**
 *
 * @returns {Generator<*, void, *>}
 */
function* addActivityLog() {
  yield takeLatest(activityLogActionTypes.ADD_ACTIVITY_LOG.REQUEST, _addActivityLog);
}

/**
 *   updateSTActivityLog
 */

function* _editActivityLog(action) {
  try {
    yield put(ActivityLogActions.editActivityLogLoading(true));
    const { payload } = action;
    const state = yield select();
    const orgId = state.UserReducers?.user?.tenant_info?.org_id;
    const activityLog = yield ActivityLogServices.editActivityLog({ ...payload, org_id: orgId });
    if (activityLog.success) {
      notification.open({
        type: 'success',
        message: 'Comment updated successfully',
        duration: 4,
        placement: 'top',
      });
    }
    if (action?.callback) action.callback();
    yield put(ActivityLogActions.editActivityLogLoading(false));
  } catch (error) {
    yield put(ActivityLogActions.editActivityLogLoading(false));
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(activityLogActionTypes.EDIT_ACTIVITY_LOG.ERROR, error));
  }
}

/**
 *
 *
 */
function* editActivityLog() {
  yield takeLatest(activityLogActionTypes.EDIT_ACTIVITY_LOG.REQUEST, _editActivityLog);
}
/**
 *
 */

function* _getHistoryActivityLog(action) {
  try {
    yield put(ActivityLogActions.getHistoryActivityLogLoading(true));
    const { payload } = action;
    const state = yield select();
    const orgId = state.UserReducers?.user?.tenant_info?.org_id;
    const activityLogHistoryComments = yield ActivityLogServices.getHistoryActivityLog({ ...payload, org_id: orgId });
    yield put(ActivityLogActions.getHistoryActivityLogSuccess(activityLogHistoryComments));
    if (action?.callback) action.callback();
    yield put(ActivityLogActions.getHistoryActivityLogLoading(false));
  } catch (error) {
    yield put(ActivityLogActions.getHistoryActivityLogLoading(false));
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(activityLogActionTypes.GET_HISTORY_LOG_MESSAGE.ERROR, error));
  }
}

function* getHistoryActivityLog() {
  yield takeLatest(activityLogActionTypes.GET_HISTORY_LOG_MESSAGE.REQUEST, _getHistoryActivityLog);
}

export default function* activityLogSaga() {
  yield all([
    getActivityLog(),
    addActivityLog(),
    editActivityLog(),
    getHistoryActivityLog(),
  ]);
}
